import React from "react";
import { useEffect, useState } from "react";

import DownloadPopupModal from "./others/DownloadPopupModal";

import { DISCOUNT_CODES } from "constants/discount";

import { getGithubZipballLink } from "utils/githubHelper";

const GumroadDownloadButton = ({
  purchaseInfo,
  classname,
  handleBuyButtonClick,
  promoCode,
  primaryEmail,
  gumroadId,
  title,
  buyButtonText,
}: {
  purchaseInfo: any;
  classname: string;
  handleBuyButtonClick: any;
  promoCode: any;
  primaryEmail?: any;
  gumroadId?: any;
  title?: any;
  buyButtonText?: string;
}) => {
  const discountCode = promoCode ?? DISCOUNT_CODES.CURRENT;

  if (!purchaseInfo) return null;

  if (purchaseInfo.directLink) {
    return (
      <a
        href={`${purchaseInfo.url}/${discountCode}`}
        target="_blank"
        data-gumroad-overlay-checkout="true"
        className="w-full"
        rel="noreferrer"
        data-umami-event="Buy Now"
        data-umami-event-gumroadID={gumroadId}
        data-umami-event-title={title}
        data-umami-event-email={primaryEmail}
      >
        <button className={classname} onClick={handleBuyButtonClick}>
          {buyButtonText ? buyButtonText : "Buy Now"}
        </button>
      </a>
    );
  }

  return (
    <a
      href={`${purchaseInfo.url}/${discountCode}`}
      className="w-full"
      target="_blank"
      rel="noreferrer"
    >
      <button className={classname} onClick={handleBuyButtonClick}>
        {buyButtonText ? buyButtonText : "Buy Now"}
      </button>
    </a>
  );
};

const ThemeBuyButton = ({
  purchaseInfo,
  downloadDetails,
  handleBuyButtonClick,
  classname,
  promoCode,
  primaryMail,
  gumroadId,
  title,
  buyButtonText,
}: {
  purchaseInfo: any;
  downloadDetails: any;
  handleBuyButtonClick: any;
  classname: string;
  promoCode: string;
  primaryMail?: string;
  gumroadId?: string;
  title?: string;
  buyButtonText?: string;
}) => {
  const [githubZipballLink, setGithubZipballLink] = useState("");
  const [showDownloadPopupModal, setShowDownloadPopupModal] = useState(false);
  const [isDownloadModalShown, SetIsDownloadModalShown] = useState(false);

  useEffect(() => {
    const isModalShown = localStorage.getItem("downloadModalShown");
    const isUser = localStorage.getItem("user");

    if (isUser || isModalShown) {
      SetIsDownloadModalShown(true);
    }
  });

  const toggleDownloadPopupModal = (event: any) => {
    setShowDownloadPopupModal(!showDownloadPopupModal);
    event.preventDefault();
  };

  useEffect(() => {
    if (downloadDetails) {
      // TODO: CHANGE HERE if multiple source for themes are added

      switch (downloadDetails[0].source) {
        case "github":
          // eslint-disable-next-line no-case-declarations
          const downloadLink = getGithubZipballLink(
            downloadDetails[0].url,
            downloadDetails[0].branch
          );

          setGithubZipballLink(downloadLink as string);
          break;

        case "direct":
          setGithubZipballLink(downloadDetails[0].url);
          break;

        default:
          break;
      }
    }
  }, []);

  if (!downloadDetails) {
    return (
      <GumroadDownloadButton
        purchaseInfo={purchaseInfo}
        classname={classname}
        handleBuyButtonClick={handleBuyButtonClick}
        promoCode={promoCode}
        primaryMail={primaryMail}
        gumroadId={gumroadId}
        title={title}
        buyButtonText={buyButtonText}
      />
    );
  }

  if (!isDownloadModalShown) {
    return (
      <>
        <button className={classname} onClick={toggleDownloadPopupModal}>
          Download
        </button>
        {showDownloadPopupModal && (
          <DownloadPopupModal
            downloadURL={githubZipballLink}
            sendTrackerEvent={handleBuyButtonClick}
            showDownloadPopupModal={showDownloadPopupModal}
            setShowDownloadPopupModal={setShowDownloadPopupModal}
          />
        )}
      </>
    );
  }

  return (
    <a href={githubZipballLink} className="w-full" download>
      <button className={classname} onClick={handleBuyButtonClick}>
        Download
      </button>
    </a>
  );
};

export default ThemeBuyButton;
